import { Suspense, lazy } from 'react'
import { Routes, Route } from 'react-router-dom'
import { Layout } from '@components/layout/Layout'
import { LoadingScreen } from '@components/ui/LoadingScreen'

// 懒加载页面组件
const HomePage = lazy(() => import('@pages/HomePage'))
const BrandEvolutionPage = lazy(() => import('@pages/BrandEvolutionPage'))
const TechLabPage = lazy(() => import('@pages/TechLabPage'))
const QualityCenterPage = lazy(() => import('@pages/QualityCenterPage'))
const SkillGardenPage = lazy(() => import('@pages/SkillGardenPage'))
const MediaHallPage = lazy(() => import('@pages/MediaHallPage'))
const InteractionZonePage = lazy(() => import('@pages/InteractionZonePage'))
const FutureOutlookPage = lazy(() => import('@pages/FutureOutlookPage'))
const NotFoundPage = lazy(() => import('@pages/NotFoundPage'))

function App() {
  return (
    <Layout>
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/brand-evolution" element={<BrandEvolutionPage />} />
          <Route path="/tech-lab" element={<TechLabPage />} />
          <Route path="/quality-center" element={<QualityCenterPage />} />
          <Route path="/skill-garden" element={<SkillGardenPage />} />
          <Route path="/media-hall" element={<MediaHallPage />} />
          <Route path="/interaction-zone" element={<InteractionZonePage />} />
          <Route path="/future-outlook" element={<FutureOutlookPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </Layout>
  )
}

export default App
